import React from 'react'
import { Col, Form, Image, Row } from 'react-bootstrap'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import moment from 'moment'

export default function StapPage4To3({ step }) {
  const detail_1 = step?.result.length > 0 ? step.result[0].groups : []
  const approve = step?.approve
  const approveSup = step?.approve_it_sup

  return (
    <>
      <Col xl={12}>
        <div className="fw-bold mb-2 "></div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_1.length > 0 &&
              detail_1.map((d, i) => (
                <Form.Check
                  key={i}
                  value={d.id}
                  readOnly
                  checked={d.is_check === 0 ? false : true}
                  label={d.equip_it_name}
                  name={`description`}
                  type="checkbox"
                  className="mb-3"
                />
              ))}
          </CheckboxCustom>
        </Checkbox.Group>
      </Col>
      {approve && (
        <Col xl={12} className="text-center mt-5 mb-5">
          <Row>
            <Col className="d-flex align-self-end justify-content-center">
              <div className=" mt-5 font-small-2 d-flex justify-content-center">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-center">
                    <Image width={250} fluid src={approve.url} />
                  </div>
                  <div className="d-flex justify-content-center">
                    ลงชื่อ
                    <div
                      style={{
                        borderBottom: '1px dashed rgb(135, 135, 135)',
                        width: 200
                      }}
                    ></div>{' '}
                    ผู้ดำเนินการ
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    ({approve.title_th}
                    {approve.name_th} {approve.surname_th})
                  </div>
                  <div className="d-flex justify-content-center fw-light mt-1">
                    {approve.position_th}
                  </div>
                  <div className="d-flex justify-content-center fw-light">
                    {moment(approve.confirm_date3).format('DD/MM/YYYY')}
                  </div>
                </div>
              </div>
            </Col>
            <Col className="d-flex align-self-end justify-content-center">
              <div className=" mt-5 font-small-2 d-flex justify-content-center">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-center">
                    {approveSup && approveSup.confirm_date3_2 !== null ? (
                      <Image width={250} fluid src={approveSup.url} />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="d-flex justify-content-center">
                    ลงชื่อ
                    <div
                      style={{
                        borderBottom: '1px dashed rgb(135, 135, 135)',
                        width: 200
                      }}
                    ></div>{' '}
                    ผู้ตรวจสอบ
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    (
                    {approveSup &&
                      `${approveSup.title_th}${approveSup.name_th} ${approveSup.surname_th}`}
                    )
                  </div>
                  <div className="d-flex justify-content-center fw-light mt-1">
                    {approveSup && approveSup.position_th}
                  </div>
                  <div className="d-flex justify-content-center fw-light">
                    {approveSup && approveSup.confirm_date3_2
                      ? moment(approveSup.confirm_date3_2).format('DD/MM/YYYY')
                      : '-'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      )}
    </>
  )
}

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px !important;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: "var(--comp-badge-color-background-primary)" !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid "var(--comp-badge-color-background-primary)";
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`
